import { ArrowUpRight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  Icon: React.FunctionComponent
  url: string
  label: string
  description: string
}

export const FigmaLink: React.FC<Props> = ({
  Icon,
  url,
  label,
  description,
}) => (
  <div className={css.link_wrap}>
    <a href={url} className={css.link} target="_blank" rel="noreferrer">
      <Icon />
      <span>{label}</span>
      <ArrowUpRight className={css.link_icon} />
    </a>

    <div className={css.information}>{description}</div>
  </div>
)
